/**
 * Resolve notebook id from server props, Next.js params, or URL path.
 * Next.js 16 async params + Activity keep-alive can briefly pass undefined props.
 */

const NOTEBOOK_PATH_RE = /\/notebook\/([^/?#]+)/

export function isValidNotebookId(id) {
  return typeof id === 'string' && id.length > 0 && id !== 'undefined'
}

/**
 * @param {string | undefined | null} propId
 * @param {{ id?: string } | undefined | null} routeParams
 * @param {string | undefined | null} pathname
 */
export function resolveNotebookId(propId, routeParams, pathname) {
  if (isValidNotebookId(propId)) return propId
  if (isValidNotebookId(routeParams?.id)) return routeParams.id
  if (typeof pathname === 'string') {
    const match = pathname.match(NOTEBOOK_PATH_RE)
    if (isValidNotebookId(match?.[1])) return match[1]
  }
  return null
}
